const Overview = ({ holidayData }) => {
  return (
    <>
      {/* <h3 className="text-22 fw-500 pt-40">Overview</h3> */}
      <div className="ql-editor" dangerouslySetInnerHTML={{ __html: holidayData }} />
      {/* <p className="text-dark-1 text-15 mt-20">
        You can directly book the best price if your travel dates are available,
        all discounts are already included. In the following house description
        you will find all information about our listing.
        <br />
        <br />
        2-room terraced house on 2 levels. Comfortable and cosy furnishings: 1
        room with 1 french bed and radio. Shower, sep. WC. Upper floor: (steep
        stair) living/dining room with 1 sofabed (110 cm, length 180 cm), TV.
        Exit to the balcony. Small kitchen (2 hot plates, oven,
      </p>
      <a
        href="#"
        className="d-block text-14 text-blue-1 fw-500 underline mt-10"
      >
        Show More
      </a> */}
    </>
  );
};

export default Overview;
